import type { ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Unreserve booking by ID.
 *
 * @endpoint POST /api/saas/me/bookings/{bookingId}/unreserve
 * @scope saas
 * @see https://flecto.dev/api-4724151
 */
export async function unreserveBooking(
  bookingId: ParameterID,
  options?: UnreserveBookingOptions
): Promise<void> {
  await api.post(`/api/saas/me/bookings/${bookingId}/unreserve`, null, {
    params: options,
  })
}

export type UnreserveBookingOptions = {
  send_sms?: boolean
  send_email?: boolean
}
